// extracted by mini-css-extract-plugin
export default {"rowContainer":"DataTable_rowContainer__kH07b","hedgedData":"DataTable_hedgedData__0GWP4","YAxis":"DataTable_YAxis__ZTUjo","tableTitle":"DataTable_tableTitle__kFzDG"};